import UIComponent from "../ui/component";
import FilesApi from "../api/files";
import goals from "../utils/goals";

export class Surcharge extends UIComponent {
    init() {
        this.includeComponents({
            errorBag: "document@.js-upload-form-error",
            payPerMinutesBtn:
                'document@[data-tbx-name="offerPayPerMinutesBtn"]',
        });

        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal:
                    'document@#regionPaymentModal',
            });
        }

        this.payPerMinutesBtn?.on("click", this.onPayPerMinuteClick.bind(this));
        this.transcodeBtn?.on("click", this.onTranscodeClick.bind(this));
        this.loadInitialData();
        goals.reach("Promo15");
    }

    async loadInitialData() {
        try {
            const fileId = window.location.pathname.split("/").pop();
            const response = await FilesApi.calculate({ files: [fileId] });

            const offers = response.offers || {};
            const hasOffers = Object.keys(offers).length > 0;

            if (hasOffers) {
                this.sub_surcharge?.show();
                this.per_minutes?.show();
                this.transcodeBtn?.hide();

                for (let i in offers) {
                    const offer = offers[i];

                    if (offer.type === "payperminute") {
                        this.updatePrice(offer);
                        if (offer.is_minimal_amount === true) {
                            this.per_minutes.mini_price?.show();
                            this.per_minutes.mini_info?.show();
                        } else {
                            this.per_minutes.max_info?.show();
                        }

                        if (
                            this.per_minutes.minute &&
                            offer.formatted_minute_cost
                        ) {
                            this.per_minutes.minute.element.textContent =
                                offer.formatted_minute_cost;
                        }
                    }
                    if (offer.type !== "subscription") {
                        this.sub_surcharge?.hide();
                    } else {
                        this.sub_surcharge?.show();
                    }
                }
            } else {
                this.sub_surcharge?.hide();
                this.per_minutes?.hide();
                this.transcodeBtn?.show();
            }
        } catch (error) {
            console.error("Failed to load initial data:", error);
            this.errorBag?.show("Failed to load file data");
        }
    }

    async onTranscodeClick(e) {
        e.preventDefault();
        goals.reach("transcode");

        const fileId = window.location.pathname.split("/").pop();
        if (!fileId || isNaN(fileId)) {
            this.errorBag?.show("Invalid file ID");
            return;
        }

        try {
            this.transcodeBtn.disable();

            const transcribeData = {
                files: [fileId],
                addToQueue: 1,
                options: { language: this.language },
            };

            await FilesApi.transcribe(transcribeData);
        } catch (error) {
            console.error("Transcode error:", error);
            this.transcodeBtn.enable();
            this.errorBag?.show(
                error.message || "Transcription processing failed"
            );
        }
    }

    async onPayPerMinuteClick(e) {
        e.preventDefault();
        goals.reach("payperminute_selected");

        const fileId = window.location.pathname.split("/").pop();
        if (!fileId || isNaN(fileId)) {
            this.errorBag?.show("Invalid file ID");
            return;
        }

        const paymentData = {
            files: [fileId],
            addToQueue: 1,
            options: { language: this.language },
            offer: "payperminute",
            return: window.location.href,
            variant: true,
        };

        if (!Number(this.available_region)) {
            this.regionPaymentModal?.show(paymentData, true);
            return;
        }

        try {
            this.payPerMinutesBtn.disable();

            FilesApi.transcribe(paymentData)
                .then((response) => {
                    this.handleOfferResponse(response);
                })
                .catch((error) => {
                    this.payPerMinutesBtn.enable();
                    this.errorBag.show(
                        error.message || "Payment processing failed"
                    );
                });
        } catch (error) {
            console.error("Payment error:", error);
            this.payPerMinutesBtn.enable();
            this.errorBag?.show(error.message || "Payment processing failed");
        }
    }

    handleOfferResponse(response) {
        if (response?.offers && Object.keys(response.offers).length > 0) {
            const offer = Object.values(response.offers).find(
                (o) => o.redirect_url
            );
            if (offer?.redirect_url) {
                const offerUrl = new URL(offer.redirect_url);
                offerUrl.searchParams.set("return", "/files");
                window.location.href = offerUrl.toString();
                return;
            }
        }
        this.errorBag.show("No payment options available");
    }

    updatePrice(offer) {
        const price = offer.amount_formatted;
        if (price !== undefined) {
            this.payPerMinutesBtn.amount = price;
        } else {
            console.warn("Price not found in response:", response);
            this.errorBag?.show("Could not determine price");
        }
    }
}
